import AdminNavbar from './AdminNavbar';
import enhance from './AdminNavbar.enhancer';

export default enhance(AdminNavbar);
